// extracted by mini-css-extract-plugin
export default {"aboutContainer":"Vision_aboutContainer__JJzXL","aboutWrapper":"Vision_aboutWrapper__+OHU0","aboutColLeft":"Vision_aboutColLeft__8xxWm","aboutColRight":"Vision_aboutColRight__q+ycI"};